<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { useAlert } from 'dashboard/composables';
import ServiceSelectionTable from '../../../../components/ServiceSelectionTable.vue';

export default {
  name: "LinkServiceModal",
  components: {
    BaseModal,
    ServiceSelectionTable,
  },
  props: {
    voucherId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isConfirming: false,
      initialSelectedIds: [],
      selectedIds: [], // store temporary selection from table
    }
  },
  methods: {
    async fetchExistingServices() {
      try {
        const res = await this.$store.dispatch('vouchers/fetchVoucherServices', this.voucherId);
        if (Array.isArray(res)) {
          this.initialSelectedIds = res.map(s => s.id);
        }
      } catch (err) {
        console.error(err);
        useAlert(`Failed to fetch services: ${err}`);
      }
    },

    handleSelection(selectedIds) {
      this.selectedIds = selectedIds;
    },

    async handleConfirm() {
      try {
        this.isConfirming = true;
        await this.$store.dispatch('vouchers/replaceVoucherServices', {
          voucherId: this.voucherId,
          services: this.selectedIds
        });

        useAlert(`Services linked to voucher successfully.`);
        this.$emit('refresh');
        this.$emit('close');
      } catch (err) {
        console.error(err);
        useAlert(`Failed to link voucher to services: ${err}`);
      } finally {
        this.isConfirming = false;
      }
    }
  },

  async mounted() {
    await this.fetchExistingServices();
  }
}
</script>

<template>
  <BaseModal size="large" @close="$emit('close')">
    <template #title> Link Services </template>

    <ServiceSelectionTable
      :initialSelectedIds="initialSelectedIds"
      @change="handleSelection"
    />

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button color-scheme="secondary" @click="$emit('close')" :disabled="isConfirming">
          Cancel
        </woot-button>

        <woot-button @click="handleConfirm" :loading="isConfirming">
          Confirm
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>
